import { AfterContentInit, Component, ContentChildren, Input, OnInit, QueryList } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { TemplateDirective } from 'shared';
import { AppStoreModel, APP_STATE_TOKEN } from '../../store';

@Component({
  selector: 'app-page-container',
  templateUrl: './page-container.component.html',
  styleUrls: ['./page-container.component.scss']
})
export class PageContainerComponent implements OnInit, AfterContentInit {

  @Input() topMargin: number = 0;

  @Input() bottomMargin: number = 0;

  @Select(APP_STATE_TOKEN) appState$: Observable<AppStoreModel>;

  @ContentChildren(TemplateDirective) templates: QueryList<TemplateDirective>;

  outsideMainContentTemplate: any;

  constructor() { }

  ngOnInit() {
  }

  ngAfterContentInit() {

    const outsideMainContent = this.templates.find(temp => temp.getType() == 'outside-main-content');

    if (outsideMainContent) {
      this.outsideMainContentTemplate = outsideMainContent.template;
    }

  }

}
